import { DialogWindow } from 'src/components/widgets/dialog';
import styled from 'styled-components';

/** Shared window dimensions for every dialog in the sales-channel switch wizard. */
export const SwitchDialogWindow = styled(DialogWindow)`
    flex-basis: 820px;
    height: calc(90vh - 20px);
    padding-left: 24px !important;
    padding-right: 24px !important;
    display: flex;
    flex-direction: column;
`;
